import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { colorDistributionActions } from '../../../../actions';
import { BlockedFeatureContext } from '../../../access/BlockedFeatureContext';
import { colorDistributionTypes } from '../../../../constants';
import { AppState } from '../../../../types/state/AppState';

export function TradedSelect() {
    const dispatch = useDispatch();
    const forTradedType: number = useSelector((state: AppState) => state.sellerBidding.colorDistribution.forTradedType);
    const isBlocked = React.useContext(BlockedFeatureContext);

    return (
        <select
            id="forTradedType"
            className="form-control form-select"
            value={forTradedType}
            disabled={isBlocked}
            onChange={e => dispatch(colorDistributionActions.tradedTypeChange(e.target.value))}
        >
            {colorDistributionTypes.traded().map(t => <option key={t.key} value={t.key}>{t.title}</option>)}
        </select>

    );
}
